export default __webpack_public_path__ + "static/media/file.92a32b4e.svg";